// dashboard/trackerCache.js
// Module-level tracker cache, keyed by pet_id, persists for the browser
// session. Read/written by PatientDetailPanel's own tracker-fetch effects;
// cleared from App.js directly on logout (shared-workstation safety) and
// on a freezeCutoff transition (stale pre-recovery data safety) — a real
// cross-cutting singleton, not something that can live fully encapsulated
// inside PatientDetailPanel.js. Extracted from App.js (2026-08-12 split).
export const _trackerCache = {};
